import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { UserProvider } from './context/UserContext'
import { ThemeProvider } from './context/ThemeContext'
import { ClientProvider } from './context/ClientContext'
import { StripeFinancialsProvider } from './context/StripeFinancialsContext'
import { ChatProvider } from './components/chat/ChatContext'
import { ToastProvider } from './components/ui/Toast'

// Push-only service worker (no caching). Registration is safe everywhere;
// browsers without support just skip it.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('Service worker registration failed:', err)
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <ThemeProvider>
          <ClientProvider>
            <StripeFinancialsProvider>
              <ChatProvider>
                <ToastProvider>
                  <App />
                </ToastProvider>
              </ChatProvider>
            </StripeFinancialsProvider>
          </ClientProvider>
        </ThemeProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
)
